import { ISimilarStocksApi } from "../types/similar-stocks-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";
export const getSimilarStocks = async (exchId: string, formattedSymbol: string) => {
  const response: { data: ISimilarStocksApi; statusCode: number; status: string; message: string } =
    await request({
      method: "POST",
      url: `${API_PATHS.scripSimilarStocks}`,
      data: {
        exchId: +exchId,
        formattedSymbol: formattedSymbol,
        limit: 6,
        offset: 1,
      },
    });
  return response;
};
